import { List, SignOut, X } from "@phosphor-icons/react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

import styles from "./SiteHeader.module.css";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { user, audience, logout } = useAuth();
  const navItems = user?.role === "teacher"
    ? [{ to: "/teacher", label: "教师工作台" }, { to: "/knowledge", label: "知识图谱" }, { to: "/cases", label: "案例库" }]
    : audience === "visitor"
      ? [{ to: "/knowledge", label: "知识图谱" }, { to: "/cases", label: "案例库" }]
      : [{ to: "/student", label: "学生首页" }, { to: "/knowledge", label: "知识图谱" }, { to: "/cases", label: "案例库" }, { to: "/projects", label: "项目工作台" }];

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <NavLink className={styles.brand} to={user?.role === "teacher" ? "/teacher" : audience === "student" ? "/student" : "/"} onClick={() => setOpen(false)}>
          <img src="/smartxiaochuan.png" alt="川小智形象" />
          <span>
            <strong>川小智</strong>
            <small>智慧城市规划学习智能体</small>
          </span>
        </NavLink>

        <button
          className={styles.menuButton}
          type="button"
          aria-expanded={open}
          aria-controls="primary-navigation"
          aria-label={open ? "关闭导航" : "打开导航"}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X size={23} /> : <List size={23} />}
        </button>

        <nav id="primary-navigation" className={open ? styles.navOpen : styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}
            >
              {item.label}
            </NavLink>
          ))}
          {user ? <button className={styles.accountButton} type="button" onClick={() => void logout()}><SignOut size={16}/>{user.display_name||"退出"}</button> : <NavLink className={styles.loginLink} to="/login/student">登录</NavLink>}
        </nav>
      </div>
    </header>
  );
}
